import download from '@/images/download.svg';
import { useTranslation } from 'react-i18next';

type DownloadThemeButtonProps = {
    image: string;
    onClick: () => void;
};

export function DownloadThemeButton({ image, onClick }: DownloadThemeButtonProps) {
    const { t } = useTranslation();
    return (
        <div className="group/badge relative flex items-center cursor-pointer rounded-[5px] transition-all duration-300 box-content overflow-hidden shadow-sm hover:shadow-md">
            <img
                className="pointer-events-none w-[150px] rounded-[5px] border border-[#F4F4F4] select-none"
                src={image}
                alt="Archireport"
            />
            <div className="absolute flex items-center justify-center border border-[#F4F4F4] w-full h-full transition-all duration-300 rounded-[5px] ease-in-out opacity-0 bg-white/100 backdrop-blur-md group-hover/badge:opacity-100 active:bg-gray-50">
                <div className="flex flex-row items-center gap-1" onClick={onClick}>
                    <img src={download} alt="Download" />
                    <span className="text-text-dark font-semibold text-sm">{t('school_download')}</span>
                </div>
            </div>
        </div>
    );
}
